const numFormat = num => {
  if (num === undefined) return 0;
  
  let n = num.toString();
  let p = n.indexOf('.');

  return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, ($0, i) => (p < 0) || (i < p) ? ($0 + ',') : $0);
}

export default numFormat;


// WEBPACK FOOTER //
// ./client/utils/numFormat.js